import { ActivityEntityName } from '../../../../entities/shared/activity.entity.name';
import { MergeDataset } from '../../decorators/decorators/merge.dataset';
import { MergeSource } from '../../decorators/decorators/merge.source';
import { AllocationMergeData, AllocationMergeSchema } from '../data/allocation.merge.data';
import { ContactMergeData, ContactMergeSchema } from '../data/contact.merge.data';

@MergeDataset({
    entity: ActivityEntityName.Allocation,
    dependsOn: [
        ActivityEntityName.Job,
        ActivityEntityName.WorkOrder
    ]
})
export class AllocationMergeDataset {

    @MergeSource({
        schema: AllocationMergeSchema
    })
    allocation: AllocationMergeData;

    @MergeSource({
        schema: ContactMergeSchema
    })
    allocationResource: ContactMergeData;

}